import React from 'react'

import { themeConfig } from '@/shared/config'
import { ConfigProvider } from 'antd'
import ruRU from 'antd/es/locale/ru_RU'

export function ThemeProvider({ children }: React.PropsWithChildren) {
  return (
    <ConfigProvider theme={themeConfig} locale={ruRU}>
      {children}
    </ConfigProvider>
  )
}
